import createGetEnumerationsSelector from './createGetEnumerationsSelector';
import { getInputSensors } from '../getInputSensors';

export const getInputEnumerations = createGetEnumerationsSelector(getInputSensors);